import { Component, Input, OnInit } from '@angular/core';
import domtoimage from 'dom-to-image';
import jsPDF from 'jspdf';
@Component({
  selector: 'app-preview-forms',
  templateUrl: './preview-forms.component.html',
  styleUrls: ['./preview-forms.component.scss']
})
export class PreviewFormsComponent implements OnInit {
  @Input() selectedTask: any;
  @Input() type: any;
  vertical:boolean = false;
  constructor() { }

  ngOnInit(): void {
    console.log("selectedTaskselectedTaskselectedTask", this.selectedTask);
    const loader = document.getElementById('loader'); // Loader element
    if (loader) loader.style.display = 'none';
    if(this.selectedTask.form_fields?.type == "multi_step"){
      // if(this.selectedTask.form_id == "66e90e667f5977ef63ac838e"){
      //   this.selectedTask?.form_fields?.fields.pop();
      // }
      this.selectedTask?.form_fields?.fields.map(el=>{
        el.component.map(e=>{
          if(e.id=="single" || e.id=="multi"){
            e.elementData.value =  e.elementData.value.replaceAll(/�/g, '');
          }
        })
      })
    }else{
      this.selectedTask?.form_fields?.fields.map(e=>{
          if(e.id=="single" || e.id=="multi"){
            e.elementData.value =  e.elementData.value.replaceAll(/�/g, '');
          }
    })
    }
   
  }

  ngOnChanges(): void {
      const loader = document.getElementById('loader'); // Loader element
      if (loader) loader.style.display = 'none';
      if(this.selectedTask.form_fields?.type == "multi_step"){
      
        this.selectedTask?.form_fields?.fields.map(el=>{
          el.component.map(e=>{
            if(e.id=="single" || e.id=="multi"){
              e.elementData.value =  e.elementData.value.replaceAll(/�/g, '');
            }
          })
        })
      }else{
        this.selectedTask?.form_fields?.fields.map(e=>{
            if(e.id=="single" || e.id=="multi"){
              e.elementData.value =  e.elementData.value.replaceAll(/�/g, '');
            }
      })
      this.vertical = false;
    }
   

    console.log("selectedTaskselectedTaskselectedTask", this.selectedTask);
  }

  ngAfterViewInit(): void {
    const loader = document.getElementById('loader'); // Loader element
    if (loader) loader.style.display = 'none';
    const submitButtons = document.querySelectorAll('#pdfHide') as NodeListOf<HTMLElement>;
      console.log("submitButtons", submitButtons);
    submitButtons.forEach(button => {
      console.log("button", button);
      button.style.display = 'none';
    });
  }


  getValueInsideSingleBracket(input) {
    input = input.join(' ');
    const regex = /\((.*?)\)/g; 
    const matches = input.match(regex); 

    if (matches) {
      return matches.join(', ').replace(/[()]/g, '');
    } else {
        return [];
    }
}

downloadFile(url: string) {
  window.open(url);
}

async downloadPDF(url: string, filename: string): Promise<void> {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error('There was an error downloading the PDF:', error);
    this.downloadFile(url);
  }
}

async viewPDF(url: string): Promise<void> {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const blob = await response.blob();
    const blobURL = window.URL.createObjectURL(blob);
    window.open(blobURL, '_blank');
    window.URL.revokeObjectURL(blobURL);
  } catch (error) {
    console.error('There was an error viewing the PDF:', error);
    this.downloadFile(url);
  }
}

generatePDFForm1() {
  const loader = document.getElementById('loader'); // Loader element
  setTimeout(() => {
    const element = document.getElementById('donwloadFormHtml');
    console.log('Element to capture:', element); // Debugging line

    if (element) {
      const downloadButton = document.getElementById('pdfHide') as HTMLElement;
      if (downloadButton) {
        downloadButton.style.display = 'none';
      }
      domtoimage.toPng(element)
        .then((dataUrl) => {
          console.log('Generated Data URL:', dataUrl); // Debugging line
          if (loader) loader.style.display = 'block';

          const pdf = new jsPDF('p', 'mm', 'a4');
          const img = new Image();
          img.src = dataUrl;
          img.onload = () => {
            const pageWidth = 210; // A4 width in mm
            const pageHeight = 297; // A4 height in mm

            const imgWidth = img.width;
            const imgHeight = img.height;

            // Calculate aspect ratio
            const aspectRatio = imgWidth / imgHeight;

            const pdfImgWidth = pageWidth; // PDF's image width
            const pdfImgHeight = pdfImgWidth / aspectRatio;

            if (pdfImgHeight > pageHeight) {
              // Content exceeds single page; split into multiple pages
              let positionY = 0;
              let remainingHeight = pdfImgHeight;

              while (remainingHeight > 0) {
                pdf.addImage(
                  dataUrl,
                  'PNG',
                  0,
                  0, // X and Y position on page
                  pdfImgWidth,
                  Math.min(remainingHeight, pageHeight) // Adjust height for current page
                );

                remainingHeight -= pageHeight; // Decrease the remaining height
                positionY += pageHeight;

                if (remainingHeight > 0) {
                  pdf.addPage();
                }
              }
            } else {
              // Content fits on a single page
              pdf.addImage(dataUrl, 'PNG', 0, 0, pdfImgWidth, pdfImgHeight);
            }

            // pdf.save('generated.pdf');
            const fileName = `${
              this.selectedTask?.formDetails?.title || 
              this.selectedTask?.form_title || 
              'Form'
            }_${
              this.selectedTask?.student_name || 
              this.selectedTask?.StudentCode || 
              'Unknown'
            }.pdf`;
            
            pdf.save(fileName);
            if (downloadButton) {
              downloadButton.style.display = 'block';
            }
          };

          img.onerror = (error) => {
            console.error('Error loading image:', error);
          };

          if (loader) loader.style.display = 'none';
          this.vertical=false;
        })
        .catch((error) => {
          console.error('Error capturing HTML:', error);
          if (downloadButton) {
            downloadButton.style.display = 'block';
          }
        });
    } else {
      console.error('No content found to generate PDF');
    }
  }, 500);
}

async generatePDFForm(): Promise<void> {
  const loader = document.getElementById('loader'); // Loader element
  
  setTimeout(async () => {
    const element = document.getElementById('donwloadFormHtmlMulti');
    if (!element) {
      console.error('Element not found!');
      return;
    }

    // Show the loader
    if (loader) loader.style.display = 'block';

    const pdf = new jsPDF('p', 'mm', 'a4'); // Portrait, millimeters, A4 size
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    try {
      // Convert the element to an image
      const canvas = await domtoimage.toPng(element, { quality: 1 });
      const img = new Image();
      img.src = canvas;

      img.onload = () => {
        const imgWidth = pdfWidth;
        const imgHeight = (img.height * imgWidth) / img.width;

        let position = 0;
        let currentHeight = imgHeight;

        // Add the first page
        pdf.addImage(img, 'PNG', 0, position, imgWidth, imgHeight);
        currentHeight -= pdfHeight;

        // Add more pages if needed
        while (currentHeight > 0) {
          position -= pdfHeight; // Move to the next page
          pdf.addPage();
          pdf.addImage(img, 'PNG', 0, position, imgWidth, imgHeight);
          currentHeight -= pdfHeight;
        }

        // Save the PDF
        const fileName = `${
          this.selectedTask?.formDetails?.title || 
          this.selectedTask?.form_title || 
          'Form'
        }_${
          this.selectedTask?.student_name || 
          this.selectedTask?.StudentCode || 
          'Unknown'
        }.pdf`;
        
        pdf.save(fileName);

        // pdf.save(`${this.selectedTask?.formDetails?.title}_${this.selectedTask?.student_id}.pdf`);

        // Hide the loader after saving
        if (loader) loader.style.display = 'none';
        this.vertical=false;
      };
    } catch (error) {
      console.error('Error generating PDF:', error);
      if (loader) loader.style.display = 'none'; // Ensure the loader hides on error
    }
  }, 500);
}

checkFieldPermission(permissions) {
  if(this.type=="company"){
    // if (this.selectedTask?.staff_status !== 'completed') {
      if (permissions?.staff.write && permissions?.staff.read) {
        return 'editable';
      } else if (!permissions?.staff.write && permissions?.staff.read) {
        return 'readOnly';
      } else {
        return 'hidden';
      }
    // }
  }else{
    // if (this.selectedTask?.staff_status !== 'completed') {
      if (permissions?.student.write && permissions?.student.read) {
        return 'editable';
      } else if (!permissions?.student.write && permissions?.student.read) {
        return 'readOnly';
      } else {
        return 'hidden';
      }
    // }
  }

}


checkDropDownFieldPermission(permissions) {
  if (this.selectedTask?.staff_status !== 'completed') {
    if (permissions?.staff.write && permissions?.staff.read) {
      return false;
    } else if (!permissions?.staff.write && permissions?.staff.read) {
      return true;
    } else {
      return true;
    }
  }
}
}
